import React from 'react';
import { Box, Paper, TextField, InputAdornment, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import AppStyles from '../styles/AppStyles';

function SearchField({
  value,
  onChange,
  onClear,
  placeholder,
  ariaLabel,
  sx = {},
}) {
  const { t } = useTranslation();
  return (
    <Paper 
      sx={{ 
        p: 0,
        mb: 3,
        background: 'transparent',
        border: 'none',
        boxShadow: 'none',
        ...sx,
      }}
    >
      <TextField
        fullWidth
        placeholder={placeholder || t('searchField.placeholder')}
        value={value}
        onChange={onChange}
        aria-label={ariaLabel || t('searchField.ariaLabel')}
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Box 
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: `linear-gradient(135deg, ${AppStyles.colors.primary.main} 0%, ${AppStyles.colors.secondary.main} 100%)`,
                  boxShadow: AppStyles.shadows.sm,
                  mr: 1,
                }}
              >
                <SearchIcon sx={{ color: AppStyles.colors.primary.contrastText, fontSize: 20 }} />
              </Box>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {value && (
                <IconButton 
                  size="small" 
                  aria-label={t('searchField.clearAriaLabel')}
                  onClick={onClear}
                  sx={{ color: AppStyles.colors.text.secondary, '&:hover': { color: AppStyles.colors.text.primary } }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: AppStyles.colors.background.paper,
            borderRadius: 999,
            minHeight: 60,
            transition: 'all 0.15s ease',
            '& fieldset': { borderColor: AppStyles.colors.border.light },
            '&:hover fieldset': { borderColor: AppStyles.colors.primary.main },
            '&.Mui-focused fieldset': { borderColor: AppStyles.colors.primary.main },
            '&.Mui-focused': { boxShadow: `0 0 0 3px ${AppStyles.colors.primary.main}20` },
          },
          '& .MuiOutlinedInput-input': {
            py: 1.75,
          },
          '& .MuiInputBase-input::placeholder': {
            color: AppStyles.colors.text.secondary,
            opacity: 0.85,
          },
        }}
      />
    </Paper>
  );
}

export default SearchField;


